import {
ref, // boolean string integer array
reactive, // Json หรือ Object
computed,
onBeforeMount,
getCurrentInstance,
watch,
} from "@vue/composition-api";
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import { EXTRA_PAYLOAD_TYPE } from "@/configs/privilege/privilege";
export default function useMangeExtraPayloadListModal(props) {

  const vm = getCurrentInstance().proxy

  const fields = [
      { key: 'field', label: 'Field' },
      { key: 'description', label: 'Description' },
      { key: 'value', label: 'Value' },
  ]

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDateString,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const loading = ref(false)

  const formData = reactive({
      privilegeId: 0,
      payloadId: 0,
      data_type: 0,
      key: "",
      value: null
    })

  const onModalOpen = () => {
      // ToDo
  }

  const selDataTypeList = ref(
    [
      {
        label: 'String (Character or Number)',
        value: EXTRA_PAYLOAD_TYPE.STRING,
      },
      {
        label: 'Int (Number)',
        value: EXTRA_PAYLOAD_TYPE.INT,
      },
      {
        label: 'Decimal',
        value: EXTRA_PAYLOAD_TYPE.DECIMAL,
      },
      {
        label: 'Boolean',
        value: EXTRA_PAYLOAD_TYPE.BOOL,
      },
      {
        label: 'Date and Time',
        value: EXTRA_PAYLOAD_TYPE.DATETIME,
      },
      {
        label: 'Json',
        value: EXTRA_PAYLOAD_TYPE.JSON,
      }
    ]
  )

  const onNumberInput = (ev, formDataValue,data_type) => {
    if(data_type == EXTRA_PAYLOAD_TYPE.INT){
      vm.$nextTick(() => {
        const inputNumber = ev.replace(/\D/g, "");
        formData[formDataValue] = inputNumber;
      });
    }
    else if(data_type == EXTRA_PAYLOAD_TYPE.DECIMAL){
      vm.$nextTick(() => {
        const inputNumber = ev.replace(/[^0-9.]/g, "");
        formData[formDataValue] = inputNumber;
      });
    }
  };

  const booleanTypeOptions = ref([
    { text: 'True', value: true },
    { text: 'False', value: false },
  ])

  const onChangeDataType = (data_type) => {
    if(data_type == EXTRA_PAYLOAD_TYPE.BOOL) {
      formData.value = true
    }
    else{
      formData.value = null
    }
      
  }

  const onSubmitModal = () => {
    if(formData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME) formData.value = resolveDateObject(validFrom)
    vm.$emit('onSubmit', formData, props.isEdit)
  }

  const resolveExampleDataType = (status) => {
    switch (status) {
      case 0:
        return "None";
      case EXTRA_PAYLOAD_TYPE.STRING:
        return "ตัวอย่าง : วัยรุ่น หรือ 0-9";
      case EXTRA_PAYLOAD_TYPE.INT:
        return "ตัวอย่าง : ตัวเลขจำนวนเต็ม เช่น 0-9";
      case EXTRA_PAYLOAD_TYPE.DECIMAL:
        return "ตัวอย่าง : ตัวเลขที่มีทศนิยม เช่น EXTRA_PAYLOAD_TYPE.INT.99";
      case EXTRA_PAYLOAD_TYPE.BOOL:
        return "";
      case EXTRA_PAYLOAD_TYPE.DATETIME:
        return "";
      case EXTRA_PAYLOAD_TYPE.JSON:
        return "";
      default:
        return "";
    }
  };

  onBeforeMount(() => {
    formData.privilegeId = props.formDataObj.privilegeId 
    formData.payloadId = props.formDataObj.payloadId 
    formData.data_type = props.formDataObj.data_type ? props.formDataObj.data_type : EXTRA_PAYLOAD_TYPE.STRING
    
    formData.key = props.formDataObj.key 
    formData.value = props.formDataObj.value 
    
    validFrom.date = formData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME ? resolveDate(formData.value) : null
    validFrom.time = formData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME ? resolveTime(formData.value) : null
  })

  return {
      fields,
      loading,
      formData,
      selDataTypeList,
      booleanTypeOptions,
      validFrom,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      EXTRA_PAYLOAD_TYPE,
      onModalOpen,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onChangeDataType,
      onSubmitModal,
      resolveExampleDataType,
      onNumberInput
  }
}